

function PositionMap() {
	return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, FormService, $q) {
			var self = this;
			this.geocodeAddress = '';

			this.map = {
				show: true,
				control: {},
				position: {},
				zoom: 6,
				events: {
					click: function(map, type, args){
						$scope.$apply(function(){
							console.log('map click', args);
							self.object[self.field.name] = self.object[self.field.name] || {}
							self.object[self.field.name].latitude = args[0].latLng.lat();
							self.object[self.field.name].longitude = args[0].latLng.lng();
						})
					}
				},
				marker: {
					position: {},
					events: {
						dragend: function(map, type, args){
							$scope.$apply(function(){
								console.log('drag end', args);
								self.object[self.field.name].latitude = args.getGMarker().position.lat();
								self.object[self.field.name].longitude = args.getGMarker().position.lng();
							})
						}
					}
				}
			}
			
			self.map.position = {latitude:52,longitude:19};
			
			$scope.$watch(function(){return self.object[self.field.name];}, function(location) {
				if (location && location.latitude && location.longitude) {
					if (self.map.position.latitude == 52) {
						if (self.map.control.refresh) self.map.control.refresh();
						self.map.position = angular.copy(self.object[self.field.name]);
						self.map.zoom = 8;
					}
					self.map.marker.position = self.object[self.field.name];
				}
			}, true);

			if (self.field.client && self.field.client.default_address) {
				var func = $parse(self.field.client.default_address);
				$scope.$watch(function(){return func(self.object);}, function(addr){
					self.geocodeAddress = addr;
				})
			}
			
			
			self.refresh = function(){
				if (self.map.control.refresh) {
					self.map.control.refresh();
					self.map.control.getGMap().setCenter({lat: self.map.position.latitude, lng: self.map.position.longitude});
				}
			}
			
			/*$scope.$watch('geocodeAddress', function(address){
				$scope.geocode(address);
			});*/
			self.geocode = function(address) {
				console.log('Geocoding', address);
				var geocoder = new google.maps.Geocoder;
				geocoder.geocode({address: address}, function(results, status) {
					if (status == 'OK') {
						console.log('Found', results);
					var latlng = results[0].geometry.location;
					self.map.control.getGMap().setCenter(latlng);
					self.map.control.getGMap().setZoom(15);
					$scope.$apply(function(){
						//self.map.zoom = 15;
						self.object[self.field.name] = self.object[self.field.name] || {}
						self.object[self.field.name].latitude = latlng.lat();
						self.object[self.field.name].longitude = latlng.lng();
					})
					
					}
				});
			}
			
			$scope.$on('editTabOn', function(){
				self.map.show = true;
				setTimeout($scope.refresh, 10);
			});
			
			window.$mapscope = $scope;

		},
		controllerAs: '$map'
	}
}


PositonMapController = function($scope, $parse) {
	
	$scope.geocodeAddress = '';

	$scope.map = {
		show: true,
		control: {},
		position: {},
		zoom: 6,
		events: {
			click: function(map, type, args){
				$scope.$apply(function(){
					console.log('map click', args);
					$scope.object.location = $scope.object.location || {}
					$scope.object.location.latitude = args[0].latLng.lat();
					$scope.object.location.longitude = args[0].latLng.lng();
				})
			}
		},
		marker: {
			position: {},
			events: {
				dragend: function(map, type, args){
					$scope.$apply(function(){
						console.log('drag end', args);
						$scope.object.location.latitude = args.gMarker.position.lat();
						$scope.object.location.longitude = args.gMarker.position.lng();
					})
				}
			}
		}
	}
	
	$scope.map.position = {latitude:52,longitude:19};
	//$scope.map.marker = {latitude:43,longitude:11};
	
	$scope.$watch('object.location', function(location) {
		if (location && location.latitude && location.longitude) {
			if ($scope.map.position.latitude == 52) {
				if ($scope.map.control.refresh) $scope.map.control.refresh();
				$scope.map.position = angular.copy($scope.object.location);
				$scope.map.zoom = 8;
			}
			$scope.map.marker.position = $scope.object.location;
			
		}
	}, true);

	if ($scope.field.client && $scope.field.client.default_address) {
		var func = $parse($scope.field.client.default_address);
		$scope.$watch(function(){return func($scope.object);}, function(addr){
			$scope.geocodeAddress = addr;
		})
	}
	 
	
	$scope.refresh = function(){
		if ($scope.map.control.refresh) {
        	$scope.map.control.refresh();
        	$scope.map.control.getGMap().setCenter({lat: $scope.map.position.latitude, lng: $scope.map.position.longitude});
        }
	}
	
	/*$scope.$watch('geocodeAddress', function(address){
		$scope.geocode(address);
	});*/
	$scope.geocode = function(address) {
		console.log('Geocoding', address);
		var geocoder = new google.maps.Geocoder;
		geocoder.geocode({address: address}, function(results, status) {
		    if (status == 'OK') {
		    	console.log('Found', results);
		      var latlng = results[0].geometry.location;
		      $scope.map.control.getGMap().setCenter(latlng);
		      $scope.map.control.getGMap().setZoom(15);
			  $scope.$apply(function(){
				//$scope.map.zoom = 15;
				$scope.object.location = $scope.object.location || {}
				$scope.object.location.latitude = latlng.lat();
				$scope.object.location.longitude = latlng.lng();
			  })
		      
		    }
		});
	}
	
	$scope.$on('editTabOn', function(){
		$scope.map.show = true;
		setTimeout($scope.refresh, 10);
	});
	
	window.$mapscope = $scope;
	
}


angular.module('forms.fields.position', ['uiGmapgoogle-maps'])
.controller('PositonMapController', PositonMapController)
.directive('positionMap', PositionMap);